import { Country } from '@afterpay/types'
export const countriesWithBillingAddressRequirements = [Country.GB, Country.US, Country.CA]
